import AppStockgum from '@/pages/AppStockgum/Template'
import Points from '@/pages/AppStockgum/Points'
import Order from '@/pages/AppStockgum/Order'
import Account from '@/pages/AppStockgum/Account'
export default {
    path: '/AppStockgum',
    component: AppStockgum,
    children: [
        {
            path: '',
            name: 'AppStockgumPoints',
            component: Points,
        },
        {
            path: ':id/:id1',
            name: 'AppStockgumOrder',
            component: Order,
        },
        {
            path: 'account',
            name: 'AppStockgumAccount',
            component: Account,
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/appstockgum.js